import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../shared-modules/material.module';
import { SharedModule } from '../../shared-modules/shared.module';
import { HpsComponent } from './hps.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        SharedModule,
        HpsComponent
    ]
})
export class HpModule { }
